module.exports = __webpack_public_path__ + "static/img/index3(1)_09.5ab03c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index3(1)_09.png
// module id = 3127
// module chunks = 1